// Use native JavaScript date formatting instead of date-fns

export const fullDateTimeFormatFR = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'full', timeStyle: 'short' });
export const dateTimeFormatFR = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeStyle: 'short' });
export const dateFormatFR = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium' });

// Helper function to pad numbers with leading zeros
const padZero = (num) => num.toString().padStart(2, '0');

export const formattedDate = (value) => {
    if (!value) return '-';
    try {
        const date = new Date(value);
        if (isNaN(date.getTime())) return '-';
        
        const day = padZero(date.getDate());
        const month = padZero(date.getMonth() + 1);
        const year = date.getFullYear();
        const hours = padZero(date.getHours());
        const minutes = padZero(date.getMinutes());
        
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
        console.error("Error formatting date:", error);
        return '-';
    }
};

// Defensive formatKey to handle string, object, or number
export function formatKey(key) {
    if (!key) return '';
    if (typeof key === 'string') return key.toLowerCase();
    if (typeof key === 'object' && key.name) return String(key.name).toLowerCase();
    return String(key).toLowerCase();
}

export const isEmpty = (value) => {
    return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
    );
};
